import { useEffect } from 'react';
import { io } from 'socket.io-client';

const sockets = new Map();

export function getSocket(namespace = '/') {
  const ns = namespace.startsWith('/') ? namespace : `/${namespace}`;
  if (sockets.has(ns)) return sockets.get(ns);
  const socket = io(ns, {
    withCredentials: true,
    autoConnect: true,
    transports: ['websocket', 'polling']
  });
  sockets.set(ns, socket);
  return socket;
}

export function disconnectAll() {
  for (const s of sockets.values()) s.disconnect();
  sockets.clear();
}

export function useSocketEvent(namespace, event, handler, deps = []) {
  useEffect(() => {
    let socket;
    try {
      socket = getSocket(namespace);
    } catch {
      return undefined;
    }
    if (!socket || !event || typeof handler !== 'function') return undefined;
    socket.on(event, handler);
    return () => {
      try { socket.off(event, handler); } catch { /* ignore */ }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [namespace, event, ...deps]);
}
